// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__SUSvt","label":"Section_label__1if-1","contentWrap":"Section_contentWrap__3ktIo","footer":"Section_footer__MJM_Q","footerInner":"Section_footerInner__wuo_l"};